<div class="help-content-wrapper" (click)="toggleClickState($event)">
  <div id="konecta-call-root"></div>

  @if (!isClicked) {
  <div class="default-state">
    <img class="help-icon-custom" src="./assets/img/svg/Pregunta.svg" alt="WhatsApp" />
    <span class="help-text">¿Necesitas ayuda?</span>
  </div>
  }

  @if (isClicked) {
  <div class="click-state-menu">
    @for (option of contactOptions; track option.label) {
    <a (click)="handleAction(option.icon === 'whatsapp-custom' ? 'whatsapp' : 'tel', 
                             option.icon === 'whatsapp-custom' ? '573001234567' : '576019876543', 
                             $event)" class="menu-option">

      @if (option.icon === 'whatsapp-custom') {
      <img class="option-icon" src="./assets/img/svg/WhatsApp_smplificado.svg" alt="WhatsApp" />
      }

      @if (option.icon === 'call') {
      <img class="option-icon" src="./assets/img/svg/Teléfono_flecha_simplificado.svg" alt="Llámanos" />
      }

      <span>{{ option.label }}</span>
    </a>
    }

  </div>
  }
</div>

  @if (isCallActive) {
  <div class="call-modal-overlay" #callModal>
    <div class="call-modal-content">

      <div class="call-icon-placeholder">
        <img src="./assets/img/svg/Teléfono-análogo.svg" alt="Llamada en curso" class="call-ringing-icon" />
      </div>

      <h3 class="modal-title">¡Ya casi estamos contigo! Solo un segundito mientras te conectamos.</h3>

      <p class="modal-instruction">
        Para que hablemos sin problemas, revisa que tu micrófono y audio estén activos, y que tengas buena señal de
        internet.
      </p>

      <button (click)="hangUpCall($event)" class="hang-up-button">
        Colgar
      </button>

    </div>
  </div>
  }